import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}product`;

export const searchProductType = (param) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/search-product-type/${param}`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const countTypes = () => axios.get(`${BaseUrl}product/product/count-types`);

